<template>
  <div>
    <h1>Logistic Partner</h1>
    <hr>

    <!-- FILTER STARTS -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
          <h4 class="panel-title">Filter Option</h4>
      </template>

      <div class="row">
        <div class="col-12 col-md-4 mt-1" style="display: flex; flex-direction: column; justify-content: space-between;">
            <label>Date Filter</label>
            <flat-pickr
                v-model="selected.range"
                :config="rangeConfig"
                placeholder="Pilih Tanggal"
            />
        </div>
            <div class="col-12 col-md-4 mt-1">
                <label for="partshopCode">Transporter</label>
                <MultiSelect 
                    v-model="filter.transporter"
                    class="mt-1"
                    :options="options.transporter"
                    :multiple="false"
                    :close-on-select="true"
                ></MultiSelect>
            </div>
            
            <div class="col-12 col-md-4" style="display: flex; align-items: flex-end;">
                <button class="btn btn-primary w-100" style="min-height:40px;margin-top:18px;background-color:#FF9700;border : 0" @click="vue_universal_table.update++"> Search</button>
            </div>
        </div>
    </panel>
    <!-- FILTER ENDS -->

    <!-- Expedition Start -->
    <div class="innerBox mt-4">

        <div class="row ml-1">
            <div class="col-md-6 col-12 row" style="padding-top:6px;">
                <div class="col" style="padding:0">
                    <button 
                        style="border-radius : 6px 0px 0px 6px;margin:0"
                        type="button" 
                        class="w-100 btn" 
                        :class="{'btn-outline-primary' : filter.type != 'AHMTOMD', 'btn-primary' : filter.type == 'AHMTOMD'}" 
                        @click="filter.type = 'AHMTOMD'"
                    >
                        AHM to MD
                    </button>
                </div>
                <div class="col" style="padding:0">
                    <button 
                        style="border-radius : 0px 6px 6px 0px;margin:0"
                        type="button" 
                        class="w-100 btn" 
                        :class="{'btn-outline-primary' : filter.type != 'MDTOD', 'btn-primary' : filter.type == 'MDTOD'}" 
                        @click="filter.type = 'MDTOD'"
                    >
                        MD to D
                    </button>
                </div>
            </div>
            <div class="col-md-6" style="display: flex; flex-direction: row-reverse;">
                <h4 style="font-weight: 600" class="Aligner-Header">Late Transporter</h4>
            </div>
        </div>
        <!-- <div class="row mt-3">
            <div class="col-md-6 col-12 mt-2 ">
                <lateTransporterPieChart 
                    class="shadow rounded"
                />
            </div>
            <div class="col-md-6 col-12 mt-2 pl-3 pr-3">
                <div class="text-right highlightFilter mb-3">
                    <button
                        type="button"
                        class="mt-1 btn btn-warning" 
                        style="height:90%;width:35%"
                        @click="exportExcel()"
                    >Download CSV <i class="fas fa-download"></i></button>
                </div>
                <table class="table tableBodyScroll text-center">
                    <thead>
                        <th>Transporter</th>
                        <th>Quantity</th>
                        <th>Late By</th>
                        <th>Sent</th>
                    </thead>
                    <tbody>
                        <tr v-for="(dat ,index) in data " :key="index"> 
                            <td>{{dat.transporter}}</td>
                            <td>{{numberWithCommas(dat.quantity)}}</td>
                            <td>{{dat.lateBy}} Day{{parseInt(dat.lateBy) > 1 ? 's' : ''}}</td>
                            <td>{{numberWithCommas(dat.sent)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> -->

        <lateTransporterPieChart
            :filter="filter"
            :update="vue_universal_table.update"
        ></lateTransporterPieChart>

        <vue-universal-table
            api_url="/api/h1/transporter-list"
            :filter="filter"
            :update="vue_universal_table.update"
            :fields="vue_universal_table.fields"
            :process_data="vue_universal_table.process_data"
            sort_by="late_hour"
            sort_order="DESC"
        ></vue-universal-table>
        
    </div>
    <!-- Expedition End -->
  </div>
</template>

<script>
    import moment from 'moment'
    const XLSX = require('xlsx')
    import MultiSelect from 'vue-multiselect'
    import flatPickr from 'vue-flatpickr-component'

    import lateTransporterPieChart from './children/lateTransporterPieChart'

    export default {
        data () {
            return {
                rangeConfig : {
                    mode : 'range',
                    dateFormat : 'Y-m-d',
                    altInput : true,
				    altInputClass: 'form-control input flatpickr-input',
                    altFormat: "j M Y"
                },

                vue_universal_table : {
                    fields : [
                        {title:'Expedition', variable:'ekspedisi'},
                        {title:'Transporter', variable:'nopol'},
                        {title:'Quantity', variable:'jumlah'},
                        {title:'Late By', variable:'late_hour'},
                    ],
                    update : 0,
                    process_data : `
                        for (var i in data) {
                            let hour = Math.floor(data[i].late_hour / 24);
                            let minutes = data[i].late_hour % 24;

                            data[i].late_hour = (hour > 0 ? hour + ' Hour(s) ' : '') + minutes + ' Minute(s)'
                        }
                    `,
                },

                options : {
                    transporter: this.$store.getters.getTransporter,
                },
                selected : {
                    range : `${moment().subtract(14, 'days').format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`
                },
                filter : {
                    type : 'AHMTOMD',
                    transporter : null,
                    start: moment().subtract(14, 'days').format("YYYY-MM-DD"),
                    end: moment().format("YYYY-MM-DD")
                },
                data : [{
                    transporter : 'B 1000 UAK',
                    quantity : 3,
                    lateBy : 3,
                    sent : 3400
                }],
                moment: moment,
            }
        },
        watch : {
        },
        components : {
            flatPickr,
            lateTransporterPieChart,
            MultiSelect
        },
        mounted () {

        },
        watch : {
            'selected.range' () {
                let dates = this.selected.range.split(" to ");

                let start;
                let end;
                if (dates.length == 1) start = end = dates[0];
                else {
                    start = dates[0];
                    end = dates[1];
                }

                if (moment(end).diff(moment(start), 'days') > 30) {
                    this.$swal.fire({
                        'title' : 'Error!',
                        'text' : `Date range cannot exceed 31 days!`,
                        'type' : 'error'
                    });

                    this.selected.range = `${moment(this.filter.start).subtract(14, 'days').format("YYYY-MM-DD")} to ${moment(this.filter.end).format("YYYY-MM-DD")}`;
                } else {
                    this.filter.start = start;
                    this.filter.end = end;
                }
            },
            'filter.type' () {
                this.vue_universal_table.update++
            }
        },
        methods : {
            exportExcel() {
                let exportFileName = `Expedition Monitoring ${new moment().format("Y-MM-DD HH:mm")}.xls`
                let wb = XLSX.utils.book_new()
                let ws = XLSX.utils.json_to_sheet(this.data, {raw: true})
                XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
                XLSX.writeFile(wb, exportFileName)
            }
        }
    }

    function isRTL () {
        return document.documentElement.getAttribute('dir') === 'rtl' || document.body.getAttribute('dir') === 'rtl'
    }
</script>

<style scoped>
    .btn-primary {
        background-color: #FF9700;
        border-color: transparent;
        box-shadow: 1px 1px 3px 3px lightgrey;
        color:white;
    }

    .btn-outline-primary {
        color: #FF9700;
        box-shadow: 0 0 0 1px #FF9700 inset;
        border-color: transparent;
    }

    .btn-outline-primary:hover {
        color: white;
        background-color: #FF9700; 
    }
</style>